// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1_Tka","footer":"ModalInfo_footer__11KLo"};